export type AiAssistNoticeId = "equipment_photo_review" | "ai_generated_example_photo";

export type AiAssistNoticeDefinition = {
  id: AiAssistNoticeId;
  version: string;
  status: "active" | "draft";
  short: string;
  body: string;
  exportText: string;
};

export const AI_ASSIST_NOTICES: Record<AiAssistNoticeId, AiAssistNoticeDefinition> = {
  equipment_photo_review: {
    id: "equipment_photo_review",
    version: "2026-05-25",
    status: "active",
    short: "AI 사진판정은 장비 점검 사진 검토용 참고 의견입니다.",
    body:
      "AI 사진판정은 사진이 체크리스트 항목 검수에 적합한지 살피는 보조 의견입니다. 실제 안전상태와 조치 필요 여부는 관리자와 현장 담당자가 확인해야 합니다.",
    exportText:
      "[equipment_photo_review v2026-05-25] AI 사진판정은 관리자 검토용 참고 의견이며, 실제 안전상태와 조치 필요 여부는 담당자가 확인해야 합니다.",
  },
  ai_generated_example_photo: {
    id: "ai_generated_example_photo",
    version: "2026-05-25",
    status: "draft",
    short: "AI 생성 예시사진은 공식 현장 사진이 아닌 검토용 후보입니다.",
    body:
      "AI 생성 예시사진은 승인 전 작업자 화면에 공식 예시처럼 노출하지 않습니다. 실제 사용 전 담당자가 장비 항목 적합성과 오인 가능성을 검토해야 합니다.",
    exportText:
      "[ai_generated_example_photo v2026-05-25] AI 생성 예시사진은 공식 현장 사진이 아닌 검토용 후보이며 승인 후 사용해야 합니다.",
  },
};
